import gql from 'not-graphql-tag';

export const QuickViewBillQuery = gql`
  query GetQuickViewBillInfo($token: String!) {
    getQuickViewBillInfo(token: $token) {
      isAccountExists
      accountNumber
      customerName
      accountType
      addressLine1
      isSummaryBillAccount
      lastPaymentDetails {
        lastPaymentAmount
        lastPaymentDate
      }
      viewBillDetails {
        encryptedAccountNumber
        isTokenExpired
        downloadBillUrl
        billStatus
        billDate
        amountDue
        dueDate
        previousBalance
        totalAdjustments
        totalCurrentCharges
        totalBalanceAfterBill
        hasBills
        encryptedBillId
        kwh
        billingPeriodStartDate
        billingPeriodEndDate
      }
      viewBillAverageTemperature {
        temperatureSource
        currentBillingPeriod {
          date
          averageTemperature
          totalCost
          totalKwh
        }
        previousBillingPeriod {
          date
          averageTemperature
          totalCost
          totalKwh
        }
      }
      viewBillMonthUsage {
        usages {
          monthName
          year
          totalKwh
        }
      }
      billInfo {
        amountDue
        balanceDueDate
        lastPaymentAmount
        dueDate
        lastPaymentDate
        isAccountPayable
        isNewAccount
        futurePaymentDate
        oneTimeFuturePaymentScheduled
        multipleFuturePaymentsScheduled
        enrolledInTPA
        billDetails {
          encryptedAccountNumber
          isTokenExpired
          downloadBillUrl
          billStatus
          billDate
          dueDate
          amountDue
          previousBalance
          totalAdjustments
          totalCurrentCharges
          totalBalanceAfterBill
          hasBills
          encryptedBillId
          kwh
          billingPeriodStartDate
          billingPeriodEndDate
        }
      }
      paymentHistoryDetails {
        paymentDate
        amountPaid
        paymentType
      }
      autoPay {
        isSameDayEnrolled
        isEnrolled
      }
      equalpay {
        paymentPlanType
      }
      isPaperlessBillEnrolled {
        result
      }
      preferredDueDate {
        dueDate {
          effectiveDate
          preferredDueDate
          status
        }
        eligibility {
          isEligible
          reasonCode
        }
      }
      pendingDisconnect {
        isPendingDisconnect
      }
      encryptedPersonId
      encryptedAccountNumber
      isTokenExpired
      tpa {
        isEligible
        isEnrolled
        accountBalance
        recommendedPaymentMonths
        enrolledInstallmentDetails {
          currentAccountBalance
          totalMonths
          payOffAmount
          recurringChargeAmount
          currentTpaMonthBalance
          monthsMatrix {
            monthNumber
            isPaymentCompleted
            doesBillExist
            paymentDate
            monthlyAmount
          }
        }
      }
      pgeEnergyTracker {
        energyTrackerInfo {
          showEnergyTracker
          identifiers
        }
        billableAccountDetails {
          isAccountBillable
          isServiceDesignationElectric
        }
      }
    }
  }
`;
